import type { Itinerary } from '$/models/Itinerary.model.ts';
import type { Trip } from '$/models/Trip.model.ts';
import isGenerationStuck from '@/utils/trip/isGenerationStuck.ts';

export type TripListItineraries = { ready: Itinerary[]; failed: Itinerary[] };

export type FailedTripCard = { itinerary: Itinerary; trip: Trip; name: string };

const tripListItineraries = (itineraries: Itinerary[], now: number): TripListItineraries => {
  const hasStopped = (itinerary: Itinerary): boolean => !itinerary.is_generating || isGenerationStuck(itinerary, now);
  const hasFailed = (itinerary: Itinerary): boolean => itinerary.failed_generation || isGenerationStuck(itinerary, now);

  return {
    ready: itineraries.filter((itinerary) => hasStopped(itinerary) && Boolean(itinerary.data?.name)),
    failed: itineraries.filter((itinerary) => hasStopped(itinerary) && hasFailed(itinerary) && !itinerary.data),
  };
};

export const pairWithTrips = (itineraries: Itinerary[], trips: Trip[] | undefined): FailedTripCard[] => {
  const tripsById = new Map((trips ?? []).map((trip) => [trip.id, trip]));

  return itineraries.flatMap((itinerary) => {
    const trip = tripsById.get(itinerary.trip_id);
    const name = trip?.data.trip_destination?.trim();

    return trip && name ? [{ itinerary, trip, name }] : [];
  });
};

export default tripListItineraries;
